import { render, staticRenderFns } from "./UserOtherInterestChangeActivationType.vue?vue&type=template&id=6f21ce8e&"
import script from "./UserOtherInterestChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./UserOtherInterestChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports